import {
  NumberField,
  RadioButton,
  TextField,
} from "../../../component/formFields";
import { useRecommendation } from "../../../contexts/recommendation-context";
import { FieldErrorMessage, Name } from "../Result";
import "styled-components/macro";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "styled-components/macro";
import { RadioProceed } from "../../../component/component.style";
import { yup } from "../../../utils/yup";
import { inputStyle } from "./PayBimaForm";
import { createDateString } from "../../../utils/helpers";
import * as mq from "../../../styles/mediaQueries";
import { useMutation } from "react-query";
import { incomeMultiplier } from "../../../utils/enquiry";
import { useEffect } from "react";
import { useParams } from "react-router";

const allianceFormSchema = yup.object({
  dob: yup
    .string()
    .required("Please enter a valid Date of Birth")
    .minYears({ minYears: 25, errorMessage: "Minimum age should be 25" })
    .maxYears({ maxYears: 65, errorMessage: "Age should be less than 65" }),
  work_email: yup
    .string()
    .required("Work email is required")
    .email("Please enter a valid email"),
  mobile_no: yup
    .string()
    .required("Mobile number is required")
    .min(10, "Please enter a valid mobile number"),
});

const defaultValues = {
  tobacco: "no",
};

function AllianceForm({ policyTerm, sumAssured }) {
  const { answers } = useRecommendation();
  const fullName = answers["name"];

  let [firstName, lastName] = ["", ""];

  if (fullName) {
    [firstName, lastName] = fullName.split(" ");
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues,
    resolver: yupResolver(allianceFormSchema),
  });

  useEffect(() => {
    defaultValues["tobacco"] = watch("tobacco");
    defaultValues["dob"] = watch("dob");
    defaultValues["work_email"] = watch("work_email");
    defaultValues["education"] = watch("education");
    defaultValues["mobile_no"] = watch("mobile_no");
  });

  const { enquiryId } = useParams();

  const { mutate: getIncomeMultiplier, data: incomeMultiplierData } =
    useMutation(() =>
      incomeMultiplier({
        age: answers["age"],
        sum_assured: sumAssured,
        annual_income: answers["income"],
        enquiryId,
      }),
    );

  useEffect(() => {
    getIncomeMultiplier();
  }, [getIncomeMultiplier]);

  const onSubmit = data => {
    let finalSumAssured = parseInt(sumAssured);
    if (incomeMultiplierData) {
      const { final_sum_assured } = incomeMultiplierData;
      if (final_sum_assured) finalSumAssured = parseInt(final_sum_assured);
    }
    const quote_data = {
      email: answers["mail"],
      workEmail: data.work_email,
      afflid: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_url: "https://termuat.elephant.in/",
      gender: answers["identify"] === "male" ? "M" : "F",
      dob: createDateString(data.dob, "yyyy-mm-dd"),
      qualification: data.education,
      annualIncome: answers["income"],
      age: answers["age"],
      term_lead_age: answers["age"],
      tobaccoHabit: data.tobacco_consumer === "yes" ? "Y" : "N",
      firstName: firstName,
      lastName: lastName,
      mobileNo: data.mobile_no,
      sumAssured: finalSumAssured,
      policyTerm: policyTerm,
      payOption: "Regular Pay",
      limitedPayTerm: "",
      payfrequency: "Monthly",
      paytypeOption: "N",
      morePlans: "",
      nomineeGets: "lumpsum",
      requestType: "filters",
    };

    const sendData = {
      ...quote_data,
    };

    fetch("https://apitermuat.elephant.in/api/common/recommend_quotes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then(res => res.json())
      .then(res => {
        window.location = res.redirect_url + res.enquiry_id;
      });
  };

  return (
    <form
      noValidate
      size="lg"
      className="d-flex flex-column align-items-center"
      onSubmit={handleSubmit(onSubmit)}
      css={`
        padding: 1em 0;
      `}
    >
      <h4 className="mb-5">
        Hey <Name>{firstName}</Name>, just a few more questions to get your
        quotes!
      </h4>
      <FormField>
        <Label>Do you consume Tobacco?</Label>
        <div className="d-flex">
          <StyledRadioButton
            {...register("tobacco")}
            value="yes"
            id="tobacco-yes"
          >
            Yes
          </StyledRadioButton>
          <StyledRadioButton
            {...register("tobacco")}
            value="no"
            id="tobacco-no"
          >
            No
          </StyledRadioButton>
        </div>
      </FormField>
      <FormField>
        <Label>Tell us your date of birth.</Label>
        <div>
          <TextInput
            type="date"
            {...register("dob")}
            min="1955-01-01"
            max="2010-12-31"
          />
          {errors.dob && (
            <FieldErrorMessage>{errors.dob.message}</FieldErrorMessage>
          )}
        </div>
      </FormField>
      <FormField>
        <Label htmlFor="education">Give us your education details</Label>
        <div
          css={`
            width: 50%;
            ${mq.sm} {
              width: 100%;
            }
          `}
        >
          <select
            id="education_streams"
            className="w-100"
            {...register("education")}
            css={`
              ${inputStyle}
            `}
          >
            {/* <option value="" disabled selected>
              Select Education
            </option> */}
            <option value="Post Graduate">Post Graduate</option>
            <option value="Graduate">Graduate</option>
            <option value="12th Pass">12th Pass</option>
            <option value="10th Pass">10th Pass</option>
          </select>
          {errors.education && (
            <FieldErrorMessage>{errors.education.message}</FieldErrorMessage>
          )}
        </div>
      </FormField>
      <FormField>
        <Label htmlFor="work_email">What is your work email id?</Label>
        <div>
          <TextInput type="text" id="work_email" {...register("work_email")} />
          {errors.work_email && (
            <FieldErrorMessage>{errors.work_email.message}</FieldErrorMessage>
          )}
        </div>
      </FormField>
      <FormField>
        <Label htmlFor="mobile_no">Tell us your mobile number.</Label>
        <div>
          <StyledNumberField
            id="mobile_no"
            {...register("mobile_no")}
            maxLength={10}
          />
          {errors.mobile_no && (
            <FieldErrorMessage>{errors.mobile_no.message}</FieldErrorMessage>
          )}
        </div>
      </FormField>
      <RadioProceed>Proceed</RadioProceed>
    </form>
  );
}

const StyledRadioButton = styled(RadioButton)`
  width: 8em;
  margin: 0.1em;
  font-size: 1.2em;
`;

const StyledNumberField = styled(NumberField)`
  margin-top: 0;
  font-size: 1rem;
  padding: 0.3em;
  ${inputStyle};
  border-radius: 0;
`;

const TextInput = styled(TextField)`
  margin-top: 0;
  font-size: 1rem;
  padding: 0.3em;
  ${inputStyle};
  border-radius: 0;
`;

const FormField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  margin-bottom: 1.6em;
  & input[type="radio"] {
    position: absolute;
    left: -1000px;
  }

  ${mq.sm} {
    flex-direction: column;
  }
`;

const Label = styled.label`
  display: block;
  text-align: center;
  font-size: 1em;
`;

export { AllianceForm };
